export const GET_TIME_ZONES = 'GET_TIME_ZONES';
export const SET_TIME_ZONES = 'SET_TIME_ZONES';
export const API_ERROR = 'LOGIN_API_ERROR';